module.exports = __webpack_public_path__ + "img/social-fb.96b13581.svg";